import {EventEmitter} from 'fbemitter'

import AWSAPI from '../../common/AWSAPI'
import Config from '../../Config'

let estimationStore = {}
const emitter = new EventEmitter()

const EstimationStore = {
  getDataFromStorage (key) {
    const storage = 'sessionStorage' in window
      ? window.sessionStorage.getItem(key)
      : null
    if (!storage || storage === '') {
      return false
    }

    if (storage === 'undefined') {
        return false
    }
    return JSON.parse(storage)
  },
  setDataToStorage (key, newData, isSilentMode = false) {
    if ('sessionStorage' in window) {
      window.sessionStorage.setItem(key, JSON.stringify(newData))
      if (!isSilentMode) {
        emitter.emit('change')
      }
    }
  },
  clearAllStorage () {
    if ('localStorage' in window) {
      window.localStorage.clear()
    }
    if ('sessionStorage' in window) {
      window.sessionStorage.clear()
    }
  },
  getData () {
    return estimationStore
  },
  setData (newData) {
    estimationStore = newData
    emitter.emit('change')
  },
  getSystemSetting (systemSettingName) {
    const onSuccess = (res) => {
      const defaulSetting = res.body.data.systemSettingValue
      EstimationStore.setDataToStorage(systemSettingName, defaulSetting)
    }
    const params = {
      command: 'get',
      systemSettingName: systemSettingName
    }
    const apiUrl = Config.companyUserApiUrl.systemSettings
    AWSAPI.apiPost('companyUser', apiUrl, params, onSuccess)
  },
  init () {
    EstimationStore.getSystemSetting('GetsugakuSetting')
    EstimationStore.getSystemSetting('KaigoSetting')
    EstimationStore.getSystemSetting('KenkouSetting')
    EstimationStore.getSystemSetting('KodomoSetting')
    EstimationStore.getSystemSetting('KoyouSetting')
    EstimationStore.getSystemSetting('NenkinSetting')
    EstimationStore.getSystemSetting('SekkeiUnitPriceSetting')
    EstimationStore.getSystemSetting('UchiwakeSetting')
    EstimationStore.setData({
      currentEstimationId: 'demo-01-01',
      isEditingCategory: false
    })
  },
  addListener (eventType, fn) {
    return emitter.addListener(eventType, fn)
  }
}

export default EstimationStore



// WEBPACK FOOTER //
// ./src/company_user/libs/EstimationStore.js